import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class TipoContenidoApi {
    
    
    static activar(id, token ) {  
       return $.ajax({
        	url: getLocacion()+ "/api/tipocontenido/activar/"+id,
           headers: {"Authorization": "Bearer " + token.idToken},
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token ) {  
       return $.ajax({
        	url: getLocacion()+ "/api/tipocontenido/"+id,
           headers: {"Authorization": "Bearer " + token.idToken},
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getTipoContenidoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
			url: getLocacion()+ "/api/tipocontenido?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			headers: {"Authorization": "Bearer " + token.idToken},
             statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getTipoContenido(id, token ) {  
         return $.ajax({
			url: getLocacion()+ "/api/tipocontenido/"+id,
			headers: {"Authorization": "Bearer " + token.idToken},
             statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(tipoContenido, token ) {          
      let tipoContenidoEnvio = Object.assign({}, tipoContenido);
		let comando="POST";
		if (tipoContenidoEnvio.id > 0) {
			comando="PUT";			
		} 
		tipoContenidoEnvio=JSON.stringify(tipoContenidoEnvio);
		return $.ajax({
			url: getLocacion()+ "/api/tipocontenido/",
            headers: {"Authorization": "Bearer " + token.idToken},
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: tipoContenidoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getTipoContenidoCombo( token ) {

		return $.ajax({
			url: getLocacion()+ "/api/tipocontenido/combo/",
            headers: {"Authorization": "Bearer " + token.idToken},
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}